import React from "react";
import { Body1, styled } from "@iventis/styles";
import { CONTACT_URL } from "@iventis/utilities";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { StyledHeader1, StyledButton, ButtonContainer, ErrorContainer } from "./error-boundary-styles";
import { UpdateImage } from "./update-image";

/**
 * Error boundary fallback component for if the version is outdated.
 * Always has reload action.
 */
export const ErrorBoundaryFallbackVersion: React.FC = () => {
    const translate = useIventisTranslate();

    return (
        <ErrorContainer>
            <StyledUpdateImage />
            <StyledHeader1>{translate(Content.errors.error_boundaries.version_error_title)}</StyledHeader1>
            <Body1>
                {translate(Content.errors.error_boundaries.version_error_message)}
                <br />
            </Body1>
            <ButtonContainer>
                <StyledButton href={CONTACT_URL} variant="outlined">
                    {translate(Content.errors.error_boundaries.contact)}
                </StyledButton>
                <StyledButton onClick={() => window.location.reload()}>{translate(Content.errors.error_boundaries.reload)}</StyledButton>
            </ButtonContainer>
        </ErrorContainer>
    );
};

const StyledUpdateImage = styled(UpdateImage)`
    width: 80%;
    max-width: 333px;
    margin: 20px 0;
`;
